import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { FIREBASE_CONFIG, FIREBASE_VAPID_KEY } from "../constant/app.constant";
import { CommonString } from "../constant/appCommonText";
import RSAencryption from "../utils/RSAencryption";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
let messaging = null;

try {
    if (!!navigator && !!navigator.platform && (navigator.platform.toLowerCase().indexOf('win') > -1 || navigator.platform.toLowerCase().indexOf('linux') > -1 || navigator.platform.toLowerCase().indexOf('mac') > -1)) {
        // Initialize Firebase
        const app = initializeApp(RSAencryption.decryptDataByATOB(FIREBASE_CONFIG));
        // Initialize Firebase Cloud Messaging and get a reference to the service
        messaging = getMessaging(app);
    }
} catch (error) {
    console.error('FCM initialize - Error: ', error);
}

const requestPushNotification = async (app) => {
    try {
        if (!!navigator && !!navigator.platform && (navigator.platform.toLowerCase().indexOf('win') > -1 || navigator.platform.toLowerCase().indexOf('linux') > -1 || navigator.platform.toLowerCase().indexOf('mac') > -1)) {
            const permission = await Notification.requestPermission();
            if (permission === "granted" && !!messaging) {
                const token = await getToken(messaging, { vapidKey: FIREBASE_VAPID_KEY });
                await app.dm.notificationDomain.registerFirebaseNotification(token);
                return false;
            } else if (permission === "denied")
                app.dm.commonDomain.showToastr("error", CommonString.DECLINE_NOTIFICATION);
        }
        return false;
    } catch (error) {
        // app.dm.commonDomain.showToastr("error", CommonString.DECLINE_NOTIFICATION);
        console.error('FCM - Error: ', error);
        return false;
    }
}

export {
    requestPushNotification
};